import { CommonEnums } from '../../common.enums';

export class Db_PropertyType {
    dbTyp_Id: number;
    el_Type: string;
    propertyType_Cd: string;
    propertyTypeNm: string;
    defaultSel: string;
    ishidden: string;
    propertyTypeLabel: string;

    constructor() {
        this.setDefaults();
    }

    setDefaults(): void {
        this.dbTyp_Id = CommonEnums.defaults.LONG_VAL;
        this.el_Type = CommonEnums.defaults.STRING_EMPTY;
        this.propertyType_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.propertyTypeNm = CommonEnums.defaults.STRING_EMPTY;
        this.defaultSel = CommonEnums.defaults.STRING_EMPTY;
        this.ishidden = CommonEnums.defaults.STRING_EMPTY;
        this.propertyTypeLabel = CommonEnums.defaults.STRING_EMPTY;
    }

    static parse(db_PropertyTypeTmp: Db_PropertyType): Db_PropertyType {
        let db_PropertyType: Db_PropertyType = new Db_PropertyType();
        db_PropertyType.copyFrom(db_PropertyTypeTmp);
        return db_PropertyType;
    }

    copy(): Db_PropertyType {
        let db_PropertyTypeTmp = new Db_PropertyType();

        db_PropertyTypeTmp.dbTyp_Id = this.dbTyp_Id;
        db_PropertyTypeTmp.el_Type = this.el_Type;
        db_PropertyTypeTmp.propertyType_Cd = this.propertyType_Cd;
        db_PropertyTypeTmp.propertyTypeNm = this.propertyTypeNm;
        db_PropertyTypeTmp.defaultSel = this.defaultSel;
        db_PropertyTypeTmp.ishidden = this.ishidden;
        db_PropertyTypeTmp.propertyTypeLabel = this.propertyTypeLabel;

        return db_PropertyTypeTmp;
    }

    copyFrom(db_PropertyTypeTmp: Db_PropertyType): void {
        this.dbTyp_Id = db_PropertyTypeTmp.dbTyp_Id;
        this.el_Type = db_PropertyTypeTmp.el_Type;
        this.propertyType_Cd = db_PropertyTypeTmp.propertyType_Cd;
        this.propertyTypeNm = db_PropertyTypeTmp.propertyTypeNm;
        this.defaultSel = db_PropertyTypeTmp.defaultSel;
        this.ishidden = db_PropertyTypeTmp.ishidden;
        this.propertyTypeLabel = db_PropertyTypeTmp.propertyTypeLabel;
    }

    compare(db_PropertyTypeTmp: Db_PropertyType): string {
        let db_PropertyTypeString: string = this.toString();
        let db_PropertyTypeTmpString: string = db_PropertyTypeTmp.toString();

        if (db_PropertyTypeString != db_PropertyTypeTmpString) {
            return db_PropertyTypeString + ', ' + db_PropertyTypeTmpString;
        }

        return '';
    }

    toString(): string {
        return "Db_PropertyType [dbTyp_Id=" + this.dbTyp_Id + ", el_Type=" + this.el_Type +
            ", propertyType_Cd=" + this.propertyType_Cd + ", propertyTypeNm=" + this.propertyTypeNm +
            ", defaultSel=" + this.defaultSel + ", ishidden=" + this.ishidden + ", propertyTypeLabel=" + this.propertyTypeLabel + "]";
    }
}